import { render } from "./List.vue?vue&type=template&id=6c6bc9a0"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6bc9a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6bc9a0', __exports__)) {
    api.reload('6c6bc9a0', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=6c6bc9a0", () => {
    api.rerender('6c6bc9a0', render)
  })

}


export default __exports__